module.exports = __webpack_public_path__ + "static/media/M.ddce654f.jpg";